// extracted by mini-css-extract-plugin
module.exports = {"navBar":"NavBar_navBar__2CEBV","breadcrumbsList":"NavBar_breadcrumbsList__1Mt_E"};